import axios from 'axios';
import Vue from 'vue';
import { getCorrelationId } from '../lib/UserSession.js';


// BusinessErrors are returned in the response with a 200 HTTP status
axios.interceptors.response.use(
  function(response) {
    if (response.status === 200) {
      if (response.data.hasOwnProperty('success') && response.data.success) {
        return response;
      }
      if (response.data instanceof Blob) {
        return response;
      }
    }
    return Promise.reject(response);
  },
  function(error) {
    // Only reject the promise if setup in the Config through rejectBusinessError.
    // Some request will need to allow the response to be passed on if the response status is not 200 and not 500:
    // For Annual statement - Business Errors cannot be rejected we have to pass the response to catch those lower down.
    if (
      error.response &&
      error.response.status !== 500 &&
      error.response.config['rejectBusinessError'] === false
    ) {
      let err = error.response;
      // Adding error message - so we can track if that this is an error code
      err.data.errors = ['BusinessError - UI allowed'];
      return err;
    } else {
      return Promise.reject(error);
    }
  }
);

const getHeaders = async (contentType?: string) => {
  return {
    Accept: 'application/json',
    Authorization: `Bearer ${await Vue.prototype.$auth.getAccessToken()}`,
    'Content-Type': contentType || 'application/json',
    'Pragma' : 'no-cache',
    'Cache-Control': 'no-cache, no-store' ,
    'X-Correlation-ID':getCorrelationId()
  };
};

const get = async (url: string) => {
  const res = await axios({
    url,
    method: 'GET',
    headers: await getHeaders(),
    crossdomain: true,
    timeout: 10000,
  } as any);
  return res.data;
};

const getBlob = async (url: string) => {
  const res = await axios({
    url,
    method: 'GET',
    headers: await getHeaders(),
    crossdomain: true,
    timeout: 30000,
    responseType: 'blob',
  } as any);
  return res.data;
};

const getBlobOrError = async (url: string) => {
  const res = await axios({
    url,
    method: 'GET',
    headers: await getHeaders(),
    crossdomain: true,
    timeout: 30000,
    responseType: 'blob',
    rejectBusinessError: false,
  } as any);
  return res.data;
};

const post = async (url: string, payload?: any, contentType?: string | undefined) => {
  const res = await axios({
    url,
    method: 'POST',
    headers: await getHeaders(contentType),
    data: payload,
    crossdomain: true,
    timeout: 30000,
  } as any);
  return res.data;
};

export { get, getHeaders, post, getBlob, getBlobOrError };
